import styled from '@emotion/styled';

export const LegacyPageImage = styled.img`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;

  -webkit-user-drag: none;

  user-select: none;

  &.is-blind {
    filter: blur(8px);
  }
`;
